export const EDGES_LIST = [
  { key: "default", isMobile: true },
  { key: "curved", isMobile: true },
  { key: "circle", isMobile: true },
  { key: "curved_br" },
  { key: "curved_bl", guest: false },
  { key: "curved_tr", guest: false },
  { key: "curved_tl", guest: false },
  { key: "drop_br" },
  { key: "drop_bl", guest: false },
  { key: "drop_tr", guest: false },
  { key: "drop_tl", guest: false },
  { key: "eye_br", guest: false },
  { key: "eye_bl" },
  { key: "drop_eye_br" },
  { key: "drop_eye_bl", guest: false },
  { key: "drop_eye_tr", guest: false },
  { key: "drop_eye_tl", guest: false },
  { key: "dots", isMobile: true },
  { key: "canvas" },
];
